import React, { useRef } from 'react';
import { useLocalStorageState } from 'ahooks';
import dayjs from 'dayjs';
import { BannerRespDTO } from '@/service/market';
import styles from './index.module.scss';
interface BannerProps {
    noticeBannerData: BannerRespDTO[];
}
const NoticeBanner: React.FC<BannerProps> = ({ noticeBannerData = [] }) => {
    const buttonRef = useRef<HTMLImageElement>(null);
    const [noticeCloseTime, setNoticeColseTime] = useLocalStorageState<
        dayjs.Dayjs | undefined
    >('homepage-notice-close-time', {
        serializer: (datetime) => datetime?.format() || '',
        deserializer: (datestr) => dayjs(datestr)
    });
    return (
        <div className={styles.container}>
            {noticeCloseTime?.date() !== dayjs().date() && (
                <div className={styles.wrap}>
                    <img
                        className={styles.close}
                        onClick={() => {
                            setNoticeColseTime(dayjs());
                        }}
                        ref={buttonRef}
                        src="https://static-s.theckb.com/BusinessMarket/Easy/PC/cancel.png"
                        alt="close"
                    />
                    <a
                        className={styles.link}
                        target="_blank"
                        href={noticeBannerData[0]?.jumpUrl}
                        rel="noreferrer"
                    >
                        <img
                            className={styles.img}
                            src={noticeBannerData[0]?.picUrl}
                            alt=""
                        />
                    </a>
                </div>
            )}
        </div>
    );
};
export default NoticeBanner;
